<script>
export default {
  props: {
    title: {
      default: undefined,
      type: String,
    },
    headingTag: {
      default: 'h4',
      type: String,
    },
    headerBorder: {
      default: false,
      type: Boolean,
    },
    headerBorderless: {
      default: false,
      type: Boolean,
    },
    background: {
      default: null,
      type: String,
    },
  },
}
</script>

<template>
  <div
    class="card"
    :class="[
      $style.plainCard,
      headerBorderless === true ? $style.headerBorderless : '',
    ]"
    :style="{ backgroundColor: background !== null ? background : '' }"
  >
    <div
      class="card-header"
      :class="[$style.header, headerBorder !== true ? $style.unBorder : '']"
      :style="{ backgroundColor: background !== null ? background : '' }"
    >
      <component
        :is="headingTag"
        :style="{
          marginBottom: 0,
          padding: '.5rem 0',
          color: 'rgba(0,0,0,.5)',
          fontWeight: '500',
        }"
        >{{ title }}</component
      >
    </div>
    <div class="card-body">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.plainCard {
  border: 1px solid $gray;
  border-radius: 0;
  [class~='card-body'] {
    ul {
      padding-left: 0;
      margin-bottom: 0;
      li {
        max-height: 3.5rem;
        padding: 0.75rem 1rem;
        list-style: none;
        a {
          color: gray;
        }
      }
    }
  }
  .header {
    border-bottom: 2px solid $gray;
    &.unBorder {
      border-bottom: 0;
    }
  }
  &.headerBorderless {
    border: none;
    .header {
      padding-left: 0;
      background: none;
    }
    [class~='card-body'] {
      background: #f7f7f7;
      border: 2px solid $gray;
    }
  }
}
</style>
